export default __webpack_public_path__ + "static/media/3b.a66c05d7.png";